import React from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
// Types
interface RequestPopupProps {
  showClose?: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
  onProceed?: () => void;
  buttonClassName?: string;
}

// Main component
export const RequestPopup: React.FC<RequestPopupProps> = ({
  showClose = true,
  onClose,
  title = "Login",
  description = "This is a preview only. To fully experience the app, create an account.",
  buttonText = "Proceed",
  onProceed,
  buttonClassName = "primary-button",
}) => {

  const handleProceed =
    onProceed || onClose

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
      onClick={showClose ? onClose : undefined}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 w-80 relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        {showClose && <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          style={{ fontSize: "24px" }}
          onClick={onClose}
        >
          <IonIcon icon={close} />
        </button>}

        <div className="flex flex-col items-center text-center">
          <h2
            className="text-xl font-bold text-center mb-2"
            style={{
              fontSize: "24px",
              fontFamily: "figTree",
              fontWeight: "700",
            }}
          >
            {title}
          </h2>

          <p
            className="text-center mb-4"
            style={{
              fontSize: "16px",
              fontWeight: "400",
              fontFamily: "figTree",
              lineHeight: "1.5",
              color: "#666",
              maxWidth: "280px",
            }}
          >
            {description}
          </p>

          <IonButton
            className={`${buttonClassName} !w-[250px]`}
            onClick={handleProceed}
          >
            {buttonText}
          </IonButton>
        </div>
      </div>
    </div>
  );
};
